// Module
var code = "<div class=\"subscription-info-dialog\"> <div class=\"close_icon\" ng-click=\"cancel()\"></div> <p id=\"subscription_name\" class=\"popup-title\">{{title}}</p> <hr> <p id=\"subscription_description\" class=\"popup-context\" ng-bind-html=\"description\"></p> </div> ";
// Exports
var _module_exports = code;;
var path = 'app/modals/subscription-info.modal.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;